<template>
  <div class="header">
    <header class="bdb-header">
      <div class="header_inner">
        <div
          class="hd-logo"
          :class="{ 'is-show': !headerLogo }"
          @click="handlePrevClick"
        >
          <i class="icon icon-hd-arrow" />
        </div>
        <div class="hd-logo2-grp" :class="{ 'is-show': headerBadabaLogo }">
          <div class="hd-logo2">
            <img
              src="@/assets/images/logo/logo_blue2.webp"
              alt="로고"
              class="img"
            />
          </div>
        </div>
        <p class="hd-ttl f-s f-bk">
          {{ hdTitle }}
        </p>

        <button
          v-if="!headerHome"
          class="btn btn-hamburger"
          :class="{ 'is-show': !headerHam }"
          @click="visibleSideNav = !visibleSideNav"
        >
          <i class="icon icon-hamburger" />
        </button>
        <button
          v-if="headerHome"
          class="btn btn-hamburger header-home-btn"
          @click="$router.push({ name: 'Home' })"
        />
      </div>
    </header>

    <layoutSideNav :visible-side-nav.sync="visibleSideNav" />
  </div>
</template>

<script>
import router from "../../router";

export default {
  name: "LayoutHeader",
  props: {
    headerLogo: {
      type: Boolean,
      default: true,
    },
    headerBadabaLogo: {
      type: Boolean,
      default: false,
    },
    headerHam: {
      type: Boolean,
      default: true,
    },
    hdTitle: {
      type: String,
      default: "", // 해당 페이지의 header title 값
    },
    headerHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleSideNav: false,
    };
  },
  methods: {
    handlePrevClick() {
      if (this.$route.name === "EstimateStep11") {
        this.$router.push({ name: "Home" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-home-btn {
  content: "";
  display: block;
  background-image: url("~@/assets/images/img/img_home_a.svg");
  background-repeat: no-repeat;
  background-size: contain;
  top: 0;
  -webkit-transform: none;
  transform: none;
}
</style>
